const getNumberOfUnreadNotifications = (notifications = []) =>
  [...notifications].filter((notification) => !notification.read).length;

export default getNumberOfUnreadNotifications;
